const initialState = {
  fetching: false
};

const account = (state = initialState, action) => {
  switch (action.type) {
  case 'FETCHING_ACCOUNT_DATA':
    return {
      ...state,
      fetching: true
    };
  case 'SAVE_ACCOUNT_DATA':
    return {
      ...state,
      ...action.accountData,
      // Set on success and on failure alike: role gates must tell "not an ambassador" apart
      // from "payload has not arrived", and every other flag is absent in both cases.
      loaded: true,
      fetching: false
    };
  case 'REMOVE_PENDING_CREDIT': {
    const filteredCreditPayments = state.pendingCreditPayments.filter(payment => payment.id !== action.paymentId);
    return {
      ...state,
      pendingCreditPayments: filteredCreditPayments
    };
  }
  case 'CANCEL_PLAN': {
    if (!state.plans) return state;
    const filteredPlans = state.plans.filter(plan => plan.alphaId !== action.planCode);
    return {
      ...state,
      plans: filteredPlans
    };
  }
  default:
    return state;
  }
};

export default account;
